import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { useTheme } from '@mui/material/styles';
import NetRisePlainLogo from '../../NRIcons/NetRisePlainLogo';

function NRSetupConnectionHeader({ leftIcon, heading }) {
  const theme = useTheme();

  const iconFrameSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(7),
    height: theme.spacing(7),
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={theme.spacing(2)} mb={theme.spacing(3)}>
      <Box display="flex" alignItems="center" gap={theme.spacing(2)}>
        <Box sx={iconFrameSx}>{leftIcon}</Box>
        <SwapHorizIcon sx={{ color: theme.palette.text.secondary }} aria-hidden />
        <Box sx={iconFrameSx}>
          <NetRisePlainLogo color={theme.palette.primary.main} height="42" width="48" />
        </Box>
      </Box>
      <Typography variant="h3" color="textPrimary" textAlign="center">
        {heading}
      </Typography>
    </Box>
  );
}

export default NRSetupConnectionHeader;
